import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=ac8f630a&scoped=true"
import script from "./groupProduct.vue?vue&type=script&lang=js"
export * from "./groupProduct.vue?vue&type=script&lang=js"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=ac8f630a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8f630a",
  null
  
)

export default component.exports